import { render, staticRenderFns } from "./faceTransfer.vue?vue&type=template&id=4f7c16ea&scoped=true&"
import script from "./faceTransfer.vue?vue&type=script&lang=js&"
export * from "./faceTransfer.vue?vue&type=script&lang=js&"
import style0 from "./faceTransfer.vue?vue&type=style&index=0&id=4f7c16ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7c16ea",
  null
  
)

export default component.exports